import { render, staticRenderFns } from "./oldnews.vue?vue&type=template&id=6a45d500&scoped=true"
import script from "./oldnews.vue?vue&type=script&lang=js"
export * from "./oldnews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a45d500",
  null
  
)

export default component.exports